import ol_Map from 'ol/Map';
import { transform as ol_proj_transform} from 'ol/proj';
import ol_control_Control from 'ol/control/Control';
import PropTypes from 'prop-types';
import { GeoCoder } from '../../geo-code';
import './geo-coder.css';
let element = document.createElement('div');

export class GeoCoderControl extends ol_control_Control {
    constructor(options = {}) {
        super({ element: element });
        this.eventListeners = {};
        this.expanded = false;
        this.locate = (options) => {
            let lonLat = [parseFloat(options.lon), parseFloat(options.lat)];
            let projection = this.getMap().getView().getProjection();
            let coord = ol_proj_transform(lonLat, 'EPSG:4326', projection);
            let view = this.getMap().getView();
            let duration = options.duration || 500;
            let resolution = options.resolution || 2.388657133911758;
            view.animate({ duration: duration, resolution: resolution }, { duration: duration, center: coord });
        };
        this.toggleExpand = () => {
            this.expanded = !this.expanded;
            this.autocompleteEl.style.display = this.expanded ? '' : 'none';
        };
        this.geoCoder = new GeoCoder(options);
        element.innerHTML = ''; //it may contain the previous element
        element.className = 'ol-control geo-coder';
        element.appendChild(this.buttonEl = this.getButtonHTML());
        element.appendChild(this.autocompleteEl = this.getAutocompleteHTML());
    }
    on(eventName, listener, option) {
        this.eventListeners[eventName] = listener;
        return listener;
    }
    getButtonHTML() {
        let buttonEl = document.createElement('button');
        buttonEl.innerHTML = 'G';
        buttonEl.addEventListener('click', this.toggleExpand, false);
        return buttonEl;
    }
    getAutocompleteHTML() {
        let autocompleteEl = document.createElement('div');
        autocompleteEl.className = 'autocomplete';
        autocompleteEl.style.display = 'none';
        let inputEl = document.createElement('input');
        inputEl.className = 'address';
        autocompleteEl.appendChild(inputEl);
        this.geoCoder.autocomplete(inputEl);
        inputEl.addEventListener('place_changed', (event) => {
            //this.locate(event.detail.lat, event.detail.lon);
            this.eventListeners['place_changed'](event);
        });
        return autocompleteEl;
    }
}